// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutUs_container__1GKwG","header":"AboutUs_header__2EQ3L","profiles":"AboutUs_profiles__1DoEX"};